// extracted by mini-css-extract-plugin
export default {"search":"css_search__tMIYX","icon":"css_icon__zcq-R","result":"css_result__ymgyZ","item":"css_item__+w51N"};